import { Platform } from 'react-native';
import { SESSION_COOKIE_NAME } from '@utils/sessionConstants';

/** Clear the httpOnly session cookie from the browser (best-effort; server logout is authoritative). */
export function clearSessionCookie(): void {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return;

  const expires = 'Thu, 01 Jan 1970 00:00:00 UTC';
  document.cookie = `${SESSION_COOKIE_NAME}=; expires=${expires}; path=/;`;
  // Legacy name from older express-session defaults
  document.cookie = `connect.sid=; expires=${expires}; path=/;`;
}
